import React from "react";
import { Grid, Section, Typography } from "../core";
import { Space } from "antd";
import styled from "styled-components";
import companyLogo from "../assets/images/logo.png";
import { media } from "../styles";
import { useSelector } from "react-redux";
const Container = styled.div`
  width: 90%;
  /* ${media.tablet`width:100%;`}
  margin: 10px 0px; */
  h3 {
    font-size: 24px;
    line-height: 36px;
    font-weight: bold;
    color: #233b67;
    margin: 0px;
    text-transform: capitalize;
  }
  p {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #233b67;
    margin: 0px;
    text-transform: capitalize;
  }
  span {
    font-weight: bold;
    text-transform: capitalize;
  }
`;
const StyledDivider = styled.div`
  width: 150px;
  height: 2px;
  border-top: 1px solid #233b67;
`;
const Image = styled.img`
  width: 70%;
`;
const LetterHead = ({ className, children, ...props }) => {
  const SingleBuyer = useSelector((state) => state.addBuyer.buyers).filter(
    (items) => {
      return items.id === props.Invoice.buyer_id;
    }
  );

  const SingleCompany = useSelector(
    (state) => state.createCompany.company
  ).filter((items) => {
    return items.id === props.Invoice.company_id;
  });
  return (
    <Section className={className} radius="10px 10px 0px 0px">
      <div>
        <div className="d-flex dir-columns">
          <div style={{ minHeight: "60mm" }}>
            <Grid>
              <div className="d-flex h-between">
                <div style={{ width: "50%" }}>
                  <Container>
                    {SingleCompany[0].companyLogo ? (
                      <Image src={companyLogo} alt="" />
                    ) : (
                      <Typography
                        color="#233b67"
                        lineHeight="initial"
                        as="h1"
                        weight="bold"
                        noMargin
                        fontSize="34px"
                      >
                        {SingleCompany[0].company_name}
                      </Typography>
                    )}
                  </Container>
                  <Container>
                    <h3>Buyer Information</h3>
                    <p>
                      <span>Company Name : </span>
                      {SingleBuyer[0].buyer_company_name}
                    </p>
                    {/* <p>P-123, ST#3 Chinab Chownk Faisalabad,Pakistan</p> */}
                    <p>
                      <span>Buyer Address :</span>
                      {SingleBuyer[0].address}
                    </p>
                    <p>
                      <span>Phone Number : </span>
                      {SingleBuyer[0].phone_number}
                    </p>
                    <p>
                      <span>NTN : </span>
                      {SingleBuyer[0].ntn}
                    </p>
                    <p>
                      <span>STRN : </span>
                      {SingleBuyer[0].strn}
                    </p>
                  </Container>
                </div>
                {/* </Row>
              <Row type="flex" justify="space-between"> */}
                <div style={{ width: "50%" }}>
                  <Container>
                    <p>
                      <span>Company Address : </span>
                      {SingleCompany[0].company_address}
                    </p>
                    <p>
                      <p>
                        <span>Phone Number : </span>
                        {SingleCompany[0].phone_no}
                      </p>
                      <span>NTN : </span>
                      {SingleCompany[0].ntn}
                    </p>
                    <p>
                      <span>STRN : </span>
                      {SingleCompany[0].strn}
                    </p>
                  </Container>

                  <Container>
                    <h3>Invoice</h3>
                    <p>
                      <span>Invoice No : </span>
                      {props.Invoice.invoice_no}
                    </p>
                    <p>
                      <span>Invoice Date : </span>
                      {props.Invoice.invoice_date}
                    </p>
                  </Container>
                </div>
              </div>
            </Grid>
          </div>
          {children}
        </div>
        <div style={{ height: "60mm" }}>
          <div className="d-flex h-between v-center h-100">
            <div>
              <div className="d-flex v-center">
                <Space>
                  <Typography
                    as="span"
                    weight="bold"
                    color="#233B67"
                    fontSize="12px"
                  >
                    Prepared By :
                  </Typography>
                  <StyledDivider></StyledDivider>
                </Space>
              </div>
              <div className="mt-30 d-flex v-center">
                <Space>
                  <Typography
                    as="span"
                    color="#233B67"
                    weight="bold"
                    fontSize="12px"
                  >
                    Checked By :
                  </Typography>
                  <StyledDivider orientation="left"></StyledDivider>
                </Space>
              </div>
            </div>
            <div>
              <StyledDivider
                style={{ width: "200px", margin: "5px 0px !important" }}
              />
              <Typography
                align="center"
                as="h6"
                color="#233B67"
                weight="bold"
                fontSize="12px"
              >
                Signature
              </Typography>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default LetterHead;
